import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductInterface } from "../interfaces/ProductInterface";
import { CategoryInterface } from "../interfaces/CategoryInterface";
import { FilterListInterface } from "../interfaces/FilterListInterface";
import { BrandingInterface } from "../interfaces/BrandingInterface";

interface LocalDataInterface {
    products: ProductInterface[];
    filters: FilterListInterface[];
    branding: BrandingInterface[];
    categories: CategoryInterface[];
    lastSync: number | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: LocalDataInterface = {
    products: [],
    filters: [],
    branding: [],
    categories: [],
    lastSync: null,
    isLoading: false,
    error: null,
};

const localDataSlice = createSlice({
    name: "localData",
    initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        setLocalData: (
            state,
            action: PayloadAction<{
                products: ProductInterface[];
                filters: FilterListInterface[];
                branding: BrandingInterface[];
                categories: CategoryInterface[];
                lastSync: number | null;
            }>,
        ) => {
            state.products = action.payload.products;
            state.filters = action.payload.filters;
            state.branding = action.payload.branding;
            state.categories = action.payload.categories;
            state.lastSync = action.payload.lastSync;
        },
    },
});

export const localDataReducer = localDataSlice.reducer;

export const { setIsLoading, setError, setLocalData } = localDataSlice.actions;
